import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import { ROUTESLIST } from "@/static/urls";
import FormField from "@/components/forms/form-field";
import OneAutocompleteField from "@/components/forms/one-autocomplete";
import { phonePattern } from "@/utils/forms.js";
import { FORMS } from "@/static/common.js";
import GoogleMapsAutocompleteField from "@/components/forms/google-maps-autocomplete";

const required = value => value ? undefined : 'Contact Name is required'

class DigitalLicenseStep1 extends Component {
  constructor(props) {
    super(props);
    this.stepSubmit = this.stepSubmit.bind(this);
  }


  stepSubmit(data) {
    // Pass data to wizard, tidak perlu API call karena cart/checkout flow
    this.props.onSubmit(data);
    return Promise.resolve();
  }

  render() {
    const { handleSubmit, submitting } = this.props;
    return (
        <form
            onSubmit={handleSubmit((data) => {
                return this.stepSubmit(data);
            })}
            className="form-layout"
            noValidate
        >
            <div className="form-row">
                <div className="form-col_2">
                    <Field
                        name="name"
                        component={FormField}
                        required={true}
                        validate={[ required ]}
                        type="text"
                        placeholder="Set First and Last Name"
                        label="Your Name:"
                    />
                </div>
                <div className="form-col_2">
                    <Field
                        name="email"
                        component={FormField}
                        type="email"
                        required={true}
                        placeholder="some@email.com"
                        label="Email:"
                    />
                </div>
            </div>
            <div className="form-row">
                <div className="form-col_2">
                    <Field
                        name="label"
                        component={OneAutocompleteField}
                        required={false}
                        type="text"
                        url="clear/label/search"
                        placeholder={FORMS.PLACEHOLDER_TBD}
                        label="Name of your Label"
                    />
                </div>
            </div>
            <div className="form-row">
                <div className="form-col_2">
                    <Field
                        name="business_address"
                        component={GoogleMapsAutocompleteField}
                        type="text"
                        required={true}
                        placeholder="Your Business Address"
                        label="Business Address"
                        note="Example: 555 Main Street, Anytown, NY, 10019"
                    />
                </div>
                <div className="form-col_2">
                    <Field
                        name="phone_number"
                        component={FormField}
                        type="text"
                        required={true}
                        {...phonePattern}
                        label="Phone #:"
                    />
                </div>
            </div>
            <div className="submit-row_txt">
                <p className="as-text">
                    By clicking Next button you are agreeing to the
                    <Link
                        to={ROUTESLIST.STATIC_TERMS}
                        className="link-thin"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Terms and Conditions.
                    </Link>
                </p>
                <div className="submit-row__btn-col">
                    <button
                        className="btn-red-primary"
                        disabled={submitting}
                        type="submit"
                    >
                        Next
                    </button>
                </div>
            </div>
        </form>
    );
  }
}

const validate = (values) => {
  const errors = {};
  if (!values.name) errors.name = "Contact Name is required";
  if (!values.email) errors.email = "Email is required";
  if (!values.business_address) errors.business_address = "Business address is required";
  if (!values.phone_number) errors.phone_number = "Phone number is required";
  return errors;
};

const DigitalLicenseStep1Form = reduxForm({
  form: "digital-license-step1",
  enableReinitialize: true,
  validate
})(DigitalLicenseStep1);

function mapStateToProps(state, ownProps) {
  // Prefill from the user profile if available
  let firstUserData = {};
  if (state.auth.user) {
    const {
      fullName,
      personal_email,
      personal_phone,
      label_name,
      business_address,
    } = state.auth.user.profile;
    firstUserData = {
      name: fullName,
      email: personal_email,
      business_address: business_address,
      phone_number: personal_phone,
      label: label_name,
    };
  }
  const filledUserData = Object.keys(firstUserData).reduce((acc, key) => {
    if (firstUserData[key]) acc[key] = firstUserData[key];
    return acc;
  }, {});

  return {
    initialValues: { ...ownProps.initialValues, ...filledUserData },
  };
}

export default connect(mapStateToProps)(DigitalLicenseStep1Form);

